export default "__VITE_ASSET__a0d26e6a__"